export const getUserByAuth = function (userId, usersList) {
  return usersList.find((rec) => rec.userId === userId);
};

export const getUserById = function (userId, usersList) {
  return usersList.find((rec) => rec.id === userId);
};
